import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { CircularProgress } from '@material-ui/core';
import { useQuerySalesStreamSummary } from '../../../../hooks';
import TotalSummarySVG from '../../../../images/sales-stream/sales-stream-summary.svg';
import TotalTicketsSoldSVG from '../../../../images/sales-stream/icons/summaryCart.svg';
import TotalTicketsHeldSVG from '../../../../images/sales-stream/icons/summaryTicket.svg';
import SalesStreamSummaryDetails from './details';
import {
  summaryCalculation,
  showSummaryDetails,
  detailsCalculation,
  showSummaryDetailsMA,
} from '../../../../helpers/sales-stream';

const useStyles = makeStyles({
  summaryLabel: {
    fontSize: '14px',
    marginLeft: '5px',
  },
  summaryNumber: {
    fontSize: '20px',
  },
  gradientNumber: {
    background: 'linear-gradient(0deg, #0783FE, #9747FF)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textFillColor: 'transparent',
  },
  summary: {
    display: 'flex',
    justifyContent: 'center',
  },
  ticketsSummary: {
    marginTop: '5px',
  },
  detailsPanel: {
    borderTop: '1px solid',
    borderImage: 'linear-gradient(90deg, #9747FF, #0783FE) 1',
    marginBottom: '10px',
  },
  loadingSummary: {
    display: 'flex',
    height: '300px',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  detailsSection: {
    padding: '10px',
    maxHeight: '650px',
    overflowY: 'auto',
    /* Scrollbar styles */
    '&::-webkit-scrollbar': {
      width: '0.9em',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#595B64',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#2A2E39',
      borderRadius: '33px',
    },
  },
});

const SalesStreamSummary = ({ filterValue, summaryData, setSummaryData, detailsData, setDetailsData }) => {
  const classes = useStyles();
  const { data, isFetching } = useQuerySalesStreamSummary(filterValue);

  useEffect(() => {
    if (data && data.summary && data.summary.stats) {
      const { stats } = data.summary;
      const totals = summaryCalculation(stats);
      setSummaryData({ ...stats, totals });
    } else {
      setSummaryData(null);
    }
    if (data && data.details && data.details.stats) {
      const { stats } = data.details;
      const detailsStats = detailsCalculation(stats);
      setDetailsData({ stats, info: detailsStats });
    } else {
      setDetailsData(null);
    }
  }, [data]);

  if (isFetching) {
    return (
      <div className={classes.loadingSummary}>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <CircularProgress size={55} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <div>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12} className={classes.summary}>
            <img src={TotalSummarySVG} alt="Summary" style={{ height: '37px' }} />
          </Grid>
          <Grid item xs={12} className={`${classes.summary} ${classes.ticketsSummary}`}>
            <img src={TotalTicketsSoldSVG} alt="Sold" style={{ heihg: '15px' }} />
            <span className={classes.summaryLabel}> Total Tickets Sold</span>
          </Grid>
          <Grid item xs={12} className={classes.summary}>
            <span className={`${classes.summaryNumber} ${classes.gradientNumber}`}>
              {summaryData && summaryData.totals ? summaryData.totals.start - summaryData.totals.current : 0}
            </span>
          </Grid>
          <Grid item xs={12} className={`${classes.summary} ${classes.ticketsSummary}`}>
            <img src={TotalTicketsHeldSVG} alt="Sold" style={{ heihg: '15px' }} />
            <span className={classes.summaryLabel}> Total Tickets Held</span>
          </Grid>
          <Grid item xs={12} className={classes.summary}>
            <span className={`${classes.summaryNumber} ${classes.gradientNumber}`}>
              {summaryData && summaryData.totals ? summaryData.totals.current : 0}
            </span>
          </Grid>
        </Grid>
      </Grid>
      {showSummaryDetails(filterValue) && (
        <div className={classes.detailsSection}>
          <Grid item xs={12} className={classes.detailsPanel}>
            <SalesStreamSummaryDetails
              details={detailsData ? detailsData.info : {}}
              showMA={showSummaryDetailsMA(filterValue)}
            />
          </Grid>
        </div>
      )}
    </div>
  );
};

SalesStreamSummary.defaultProps = {
  filterValue: [],
  summaryData: {},
  setSummaryData: undefined,
  detailsData: {},
  setDetailsData: undefined,
};

SalesStreamSummary.propTypes = {
  filterValue: PropTypes.array,
  summaryData: PropTypes.object,
  setSummaryData: PropTypes.func,
  detailsData: PropTypes.object,
  setDetailsData: PropTypes.func,
};

export default SalesStreamSummary;
